'use client';
import React, { useEffect, useRef } from 'react';

const news = [
  {
    date: '30 Des 2025',
    title: 'Terima Bantuan Program PKT 2025 dari DPPKUKM Kalimantan Timur',
    image: '/assets/images/news/9.jpg',
    imageAlt: 'Penyerahan bantuan Program PKT 2025 dari DPPKUKM Kalimantan Timur',
    excerpt: 'Agro Teknologi Nusantara menerima bantuan Program PKT 2025 dari DPPKUKM Kalimantan Timur sebagai bentuk dukungan terhadap perkembangan sektor pertanian modern di daerah.',
  },
  {
    date: '8 Des 2025',
    title: 'Dukung Akselerasi Peternak Milenial untuk Perkuat Ketahanan Pangan',
    image: '/assets/images/news/8.jpg',
    imageAlt: 'Dukungan untuk akselerasi peternak millennial',
    excerpt: 'Perusahaan turut mendukung program akselerasi peternak dan petani millennial untuk memperkuat ketahanan pangan di Kalimantan Timur melalui teknologi smart farming.',
  },
  {
    date: '20 Nov 2025',
    title: 'Tim Riset Agro Teknologi Nusantara Mengikuti Workshop RFID 2025',
    image: '/assets/images/news/7.jpg',
    imageAlt: 'Tim riset mengikuti workshop RFID 2025',
    excerpt: 'Tim riset Agro Teknologi Nusantara berpartisipasi dalam Workshop RFID 2025 untuk mengeksplorasi penerapan teknologi identifikasi frekuensi radio dalam sistem pertanian cerdas.',
  },
  {
    date: '24 Sep 2025',
    title: 'Agro Teknologi Nusantara Terima 14 Peserta Magang Smart Farming dari BPVP Samarinda',
    image: '/assets/images/news/6.jpg',
    imageAlt: '14 peserta magang smart farming dari BPVP Samarinda',
    excerpt: 'Agro Teknologi Nusantara menerima 14 peserta magang Smart Farming dari BPVP (Balai Pelatihan Vokasi) Samarinda dalam program pembelajaran langsung di lokasi.',
  },
  {
    date: '21 Agt 2025',
    title: 'Agro Teknologi Nusantara Dampingi Petani Milenial Terapkan Smart Farming di Lapangan',
    image: '/assets/images/news/5.jpg',
    imageAlt: 'Pendampingan petani millennial menerapkan smart farming',
    excerpt: 'Tim Agro Teknologi Nusantara melakukan pendampingan langsung kepada petani millennial dalam penerapan teknologi smart farming di lapangan, menggunakan perangkat IoT dan sistem monitoring real-time.',
  },
  {
    date: '12 Jul 2025',
    title: 'CEO Agro Teknologi Nusantara Berikan Motivasi pada Pelatihan Smart Farming di Kutai Kartanegara',
    image: '/assets/images/news/4.jpg',
    imageAlt: 'CEO memberikan motivasi pada pelatihan smart farming',
    excerpt: 'CEO Agro Teknologi Nusantara memberikan motivasi dan pembukaan pada pelatihan Smart Farming yang diselenggarakan di Kutai Kartanegara, diikuti puluhan peserta dari berbagai daerah.',
  },
  {
    date: '11 Jul 2025',
    title: 'Distanak Kukar Dorong Modernisasi Pertanian Lewat Pelatihan Smart Farming bagi Penyuluh Swadaya',
    image: '/assets/images/news/3.webp',
    imageAlt: 'Pelatihan smart farming bagi penyuluh swadaya',
    excerpt: 'Distanak Kutai Kartanegara mendorong modernisasi pertanian melalui pelatihan Smart Farming bagi penyuluh swadaya, kolaborasi dengan Agro Teknologi Nusantara sebagai teknis.',
  },
  {
    date: '27 Jun 2025',
    title: 'Peda XI Petani Nelayan Kalimantan Timur 2025, Gubernur Harum: Jangan Biarkan Lahan Tidur',
    image: '/assets/images/news/1.jpg',
    imageAlt: 'Peda XI Petani Nelayan Kalimantan Timur 2025',
    excerpt: 'Perusahaan hadir dalam Peda XI Petani Nelayan Kalimantan Timur 2025 dengan tema optimalisasi lahan tidur dan penerapan teknologi pertanian modern.',
  },
  {
    date: '23 Apr 2025',
    title: 'Pertemuan Teknis Kelembagaan Pertanian Kalimantan Timur',
    image: '/assets/images/news/2.jpg',
    imageAlt: 'Pertemuan teknis kelembagaan pertanian',
    excerpt: 'Tim Agro Teknologi Nusantara terlibat dalam pertemuan teknis kelembagaan pertanian Kalimantan Timur untuk mendiskusikan integrasi teknologi IoT dalam sistem pertanian daerah.',
  },
];

export default function NewsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    const els = sectionRef.current?.querySelectorAll('.reveal, .reveal-left, .reveal-right');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="news" ref={sectionRef} className="relative">
      <div className="bg-canopy blueprint-grid py-20 px-6 md:px-10 relative">
        <div className="max-w-7xl mx-auto">
          <div className="reveal flex items-center gap-4 mb-6">
            <div className="w-12 h-px bg-chartreuse opacity-60" />
            <span className="annotation">BERITA TERBARU</span>
          </div>
          <h2 className="reveal delay-100 font-mono font-bold text-4xl md:text-6xl text-text-primary leading-tight">
            KABAR TERBARU<br />
            <span className="text-chartreuse"></span>
          </h2>
          <p className="reveal delay-200 text-text-muted text-lg mt-6 max-w-2xl leading-relaxed">
            Berita dan aktivitas terkini.
          </p>
        </div>
        <div className="absolute bottom-0 left-0 right-0 rule-line" />
      </div>
      <div className="bg-pond blueprint-grid py-16 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((item, i) => (
              <article
                key={item.title}
                className={`reveal delay-${(i % 3) * 100} group border border-chartreuse/10 rounded-sm overflow-hidden bg-canopy/30 hover:border-chartreuse/30 transition-all duration-300 hover:-translate-y-1`}
              >
                <div className="relative overflow-hidden h-48">
                  <img
                    src={item.image}
                    alt={item.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                    }}
                    style={{
                    filter: 'opacity(0.86)',
                  }}

                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-canopy/60 to-transparent" />
                </div>
                <div className="p-6">
                  <div className="font-mono text-[9px] text-chartreuse tracking-widest mb-2">{item.date}</div>
                  <h3 className="font-mono font-bold text-text-primary text-sm mb-3 leading-snug line-clamp-2 group-hover:text-chartreuse transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-text-muted text-xs leading-relaxed line-clamp-3 mb-4">
                    {item.excerpt}
                  </p>
                  <a
                    href="#news"
                    className="font-mono text-[10px] text-chartreuse tracking-widest uppercase hover:underline"
                  >
                    Baca Selengkapnya →
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 rule-line" />
    </section>);
}
